        import React from "react";
import PicsCard from "./PicsCard";

function Gallery(){
    return <div>
  
<PicsCard event="Swachh Diwali Shubh Diwali 2023"
        imga="../images/Gallery/G6.jpg"
        imgb="../images/Gallery/G5.jpg"
        imgc="../images/Gallery/G7.jpg"
        />
<PicsCard event="15TH Tribal Youth Exchange Programme 2023"
        imga="../images/Gallery/V2.jpg"
        imgb="../images/Gallery/V1.jpg"
        imgc="../images/Gallery/V3.jpg"
        />  
<PicsCard event="National Level Programme MMMD 2023"
        imga="../images/Gallery/W2.jpg"
        imgb="../images/Gallery/W1.jpg"
        imgc="../images/Gallery/W3.jpg"
        />
<PicsCard event="Amrit Kalash Yatra 2023"
        imga="../images/Gallery/U2.jpg"
        imgb="../images/Gallery/U1.jpg"
        imgc="../images/Gallery/U3.jpg"
        />
<PicsCard event="NSS Day Celebrations 2023"
        imga="../images/Gallery/H5.jpg"
        imgb="../images/Gallery/H6.jpg"
        imgc="../images/Gallery/H4.jpg"
        />
<PicsCard event=" NSS ORIENTATION DAY 2023 "
        imga="../images/Gallery/L4.jpg"
        imgb="../images/Gallery/L5.jpg"
        imgc="../images/Gallery/L6.jpg"
        />
<PicsCard event="Matti Vinayaka Distribution 2023"
        imga="../images/Gallery/F7.jpg"
        imgb="../images/Gallery/F8.jpg"
        imgc="../images/Gallery/F9.jpg"
        />
<PicsCard event="Hyderabad Liberation Day 2023"
        imga="../images/Gallery/T1.jpg"
        imgc="../images/Gallery/T2.jpg"
        imgb="../images/Gallery/T3.jpg"
        />
<PicsCard event="Independence Day 2023"
        imga="../images/Gallery/F4.jpg"
        imgb="../images/Gallery/F5.jpg"
        imgc="../images/Gallery/F6.jpg"
        />
<PicsCard event="Plantation Drive 2023"
        imga="../images/Gallery/S1.jpg"
        imgb="../images/Gallery/S2.jpg"
        imgc="../images/Gallery/S3.jpg"
        />
<PicsCard event="Meri Maati Mera Desh 2023"
        imga="../images/Gallery/R1.jpg"
        imgb="../images/Gallery/R2.jpg"
        imgc="../images/Gallery/R3.jpg"
        />

<PicsCard event="District Level Yuva Utsav - 2023"
        imga="../images/Gallery/Q1.jpg"
        imgb="../images/Gallery/Q2.jpg"
        imgc="../images/Gallery/Q3.jpg"
        />   
<PicsCard event="14th Youth Tribal Exchange Programme 2023"
        imga="../images/Gallery/p1.jpg"
        imgb="../images/Gallery/P2.jpg"
        imgc="../images/Gallery/P3.jpg"
        />
<PicsCard event="Training on Youth Leadership and Community Development 2023 "
        imga="../images/Gallery/D8.jpg"
        imgb="../images/Gallery/D7.jpg"
        imgc="../images/Gallery/D9.jpg"
        />
<PicsCard event="Republic Day 2023"
        imga="../images/Gallery/O1.jpg"
        imgb="../images/Gallery/O2.jpg"
        imgc="../images/Gallery/O3.jpg"

        />
<PicsCard event="National Level Youth Festival 2023"
        imga="../images/Gallery/N3.jpg"
        imgb="../images/Gallery/N1.jpg"
        imgc="../images/Gallery/N2.jpg"

        />
<PicsCard event="State Level Youth Festival Warangal 2022"
        imga="../images/Gallery/M1.jpg"
        imgb="../images/Gallery/M2.jpg"
        imgc="../images/Gallery/M3.jpg"

        />
<PicsCard event="NSS Orientation Day 2022"
        imga="../images/Gallery/L1.jpg"
        imgb="../images/Gallery/L2.jpg"
        imgc="../images/Gallery/L3.jpg"

        />
<PicsCard event="Bathukamma Sandhadi 2022"
        imga="../images/Gallery/b1.jpg"
        imgb="../images/Gallery/b2.jpg"
        imgc="../images/Gallery/b3.jpg"

        />

<PicsCard event="NSS Day - 2022"
        imga="../images/Gallery/A1.jpg"
        imgb="../images/Gallery/A2.jpg"
        imgc="../images/Gallery/A3.jpg"
        />
<PicsCard event=" Kanika Vinayaka Distribution 2022"
        imga="../images/Gallery/A8.jpg"
        imgb="../images/Gallery/A9.jpg"
        imgc="../images/Gallery/A10.jpg"

        />

<PicsCard event="Svatantra Bharatha Vajrotsavalu 2022"
        imga="../images/Gallery/C1.jpg"
        imgb="../images/Gallery/C2.jpg"
        imgc="../images/Gallery/C3.jpg"

        />
<PicsCard event="Azadi Ka Amrit Mahotsav Bike Rally"
        imga="../images/Gallery/A7.jpg"
        imgb="../images/Gallery/A6.jpg"
        imgc="../images/Gallery/A5.jpg"

        />
<PicsCard event=" International Yoga Day 2022"
        imga="../images/Gallery/E7.jpg"
        imgb="../images/Gallery/E9.jpg"
        imgc="../images/Gallery/E8.jpg"
        />
<PicsCard event="Plantation Drive 2022"
        imga="../images/Gallery/E5.jpg"
        imgb="../images/Gallery/E6.jpg"
        imgc="../images/Gallery/E4.jpg"
        />
<PicsCard event=" National Integration Camp at Sultanpur 2022"
        imga="../images/Gallery/I4.jpg"
        imgb="../images/Gallery/I5.jpg"
        imgc="../images/Gallery/I6.jpg"

        />

<PicsCard event="Red Ribbon Campaign"
        imga="../images/Gallery/D2.jpg"
        imgb="../images/Gallery/D3.jpg"
        imgc="../images/Gallery/D1.jpg"

        />
<PicsCard event=" Inspire - KIYEF"
        imga="../images/Gallery/b7.jpg"
        imgb="../images/Gallery/b8.jpg"
        imgc="../images/Gallery/b9.jpg"

        />
<PicsCard event=" Srishthi - 2022 "
        imga="../images/Gallery/F2.jpg"
        imgb="../images/Gallery/F1.jpg"
        imgc="../images/Gallery/F3.jpg"

        />

<PicsCard event="National Youth Parliment 2022"
        imga="../images/Gallery/E1.jpg"
        imgb="../images/Gallery/E2.jpg"
        imgc="../images/Gallery/E3.jpg"

        />
<PicsCard event="Swach Bharath 2021"
        imga="../images/Gallery/I1.jpg"
        imgb="../images/Gallery/I2.jpg"
        imgc="../images/Gallery/I3.jpg"

        />
<PicsCard event="Covid Vaccination Drive 2021"
        imga="../images/Gallery/G1.jpg"
        imgb="../images/Gallery/G3.jpg"
        imgc="../images/Gallery/G2.jpg"
        />
<PicsCard event=" National Integration Camp at Haryana 2021 "
        imga="../images/Gallery/C7.jpg"
        imgb="../images/Gallery/C8.jpg"
        imgc="../images/Gallery/C9.jpg"
        />

<PicsCard event="Bathukamma Sandhadi 2021" 
            imga="../images/Gallery/b4.jpg"
            imgb="../images/Gallery/b5.jpg"
            imgc="../images/Gallery/b6.jpg"
        />
<PicsCard event=" NSS DAY 2021 "
        imga="../images/Gallery/C4.jpg"
        imgb="../images/Gallery/C6.jpg"
        imgc="../images/Gallery/C5.jpg"
        />
<PicsCard event="FIT INDIA Movement 2.0 2021"
        imga="../images/Gallery/J2.jpg"
        imgb="../images/Gallery/J1.jpg"
        imgc="../images/Gallery/J3.jpg"
        />
<PicsCard event="6th Pravasi Telangana Divas 2021" 
            imga="../images/Gallery/H1.jpg"
            imgb="../images/Gallery/H2.jpg"
            imgc="../images/Gallery/H3.jpg"
        />
        
    </div>;
}

export default Gallery;